export default __webpack_public_path__ + "static/media/1-3-2.84841274.webp";